import { getHashtagsCount } from 'helpers/getHashTagsCount';
import { MAX_CONTENT_LENGTH, MAX_HASHTAGS_COUNT, MAX_NAME_LENGTH } from './common';
import { ValidationMessages } from 'constants/validation-messages';

export const nameValidationRules = {
  required: ValidationMessages.snippetsName.required,
  maxLength: {
    value: MAX_NAME_LENGTH,
    message: ValidationMessages.snippetsName.maxLength
  }
};

export const contentValidationRules = {
  required: ValidationMessages.snippetsContent.required,
  validate: {
    content(data: string): string | boolean {
      if (getHashtagsCount(data) > MAX_HASHTAGS_COUNT || data.length > MAX_CONTENT_LENGTH) {
        return ValidationMessages.snippetsContent.hashtagAndMaxLength;
      }

      return true;
    }
  }
};
